// extracted by mini-css-extract-plugin
module.exports = {"c-footer-legal":"_84ff5fbbc9--c-footer-legal--2Ng9i"};